// extracted by mini-css-extract-plugin
export default {"answer":"Eaa-z","bestAnswerHeading":"Faa-z","meta":"Gaa-z"};